import { inject } from "@angular/core";
import { Router, type CanActivateFn, type UrlTree } from "@angular/router";

import { AuthStateService } from "../services/auth-state.service";

/**
 * The Members page: a customer admin managing their own organization.
 *
 * A UI affordance, not a security boundary. customer-portal-api checks the
 * `customer-admin` role on the verified token for every Members request.
 */
export const customerAdminGuard: CanActivateFn = (): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  return authState.isCustomerAdmin() ? true : router.createUrlTree(["/forbidden"]);
};
